"use client";

import React from "react";
import { MousePointerClick } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pins = [{
  top: "32%",
  left: "18%",
  color: "secondary"
}, {
  top: "45%",
  left: "25%",
  color: "primary"
}, {
  top: "58%",
  left: "21%",
  color: "secondary"
}, {
  top: "68%",
  left: "28%",
  color: "primary"
}, {
  top: "82%",
  left: "33%",
  color: "secondary"
}, {
  top: "90%",
  left: "29%",
  color: "primary"
}, {
  top: "28%",
  left: "48%",
  color: "primary"
}, {
  top: "35%",
  left: "54%",
  color: "secondary"
}, {
  top: "48%",
  left: "50%",
  color: "primary"
}, {
  top: "65%",
  left: "53%",
  color: "secondary"
}, {
  top: "80%",
  left: "55%",
  color: "primary"
}, {
  top: "55%",
  left: "68%",
  color: "secondary"
}, {
  top: "42%",
  left: "78%",
  color: "primary"
}];
export default function GlobalPartnersMap() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="global-partners-map" className="bg-background py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground leading-tight">
            Naši klijenti i{" "}
            <span className="text-secondary">
              ovlašteni partneri
              <br className="hidden sm:block" /> diljem svijeta
            </span>
          </h2>
        </div>

        <div ref={ref} className={`relative w-full max-w-5xl mx-auto aspect-[4/3] sm:aspect-[2/1] transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/dotted_world_map_pattern.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/dotted_world_map_pattern.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/dotted_world_map_pattern.png-wvc-sizes" alt="World Map" className="w-full h-full object-contain opacity-30 dark:opacity-20 pointer-events-none" loading="lazy" />

          {}
          {pins.map((pin, i) => <div key={i} data-index={i} className="absolute -translate-x-1/2 -translate-y-full transition-transform duration-300 hover:scale-110 hover:-translate-y-[calc(100%+4px)] cursor-default" style={{
          top: pin.top,
          left: pin.left
        }}>
              <div className="relative flex flex-col items-center">
                {}
                <div className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-background border-2 flex items-center justify-center z-10 shadow-md ${pin.color === "primary" ? "border-primary text-primary" : "border-secondary text-secondary"}`}>
                  <MousePointerClick className="w-4 h-4 sm:w-5 sm:h-5" />
                </div>
                {}
                <div className={`w-3 h-3 sm:w-4 sm:h-4 -mt-1.5 sm:-mt-2 rotate-45 border-r-2 border-b-2 bg-background shadow-sm ${pin.color === "primary" ? "border-primary" : "border-secondary"}`} />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}